<template>
  <v-dialog
    value="true"
    :max-width="maxWidth"
    :persistent="persistent"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title
        class="title font-weight-bold"
        v-if="title"
        v-text="title"
      ></v-card-title>
      <v-card-text :class="{ 'pt-4': !title }" v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="btnCancelColor"
          text
          :disabled="loading"
          @click="cancel"
          >{{ btnCancelText }}</v-btn
        >
        <v-btn
          :color="btnOkColor"
          text
          :disabled="loading"
          :loading="loading"
          @click="proceed"
          >{{ btnOkText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    btnOkText: {
      type: String,
      default: 'Ok'
    },
    btnCancelText: {
      type: String,
      default: 'Cancel'
    },
    btnOkColor: {
      type: String,
      default: 'primary'
    },
    btnCancelColor: {
      type: String,
      default: 'grey'
    },
    loader: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    },
    persistent: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    maxWidth: {
      type: Number,
      default: 400
    },
    promiseResolver: {
      type: Function,
      default: () => {}
    },
    promiseRejecter: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    toggleLoading (loading = null) {
      if (loading === null) {
        loading = !this.loading
      }
      this.loading = !!loading
    },
    proceed () {
      if (this.loader) {
        this.toggleLoading(true)
        this.promiseResolver({
          close: this.close,
          loading: this.toggleLoading
        })
      } else {
        this.promiseResolver(true)
        this.close()
      }
    },
    cancel () {
      if (this.loading) return
      this.$emit('cancel')
      this.close()
    },
    close () {
      this.loading = false
      this.$emit('close')
      this.$destroy()
    }
  }
}
</script>
